export default "__VITE_ASSET__BeWggZFy__"